module.exports = __webpack_public_path__ + "img/企业信用AAA等级证书.81e11b8a.png";